import { collectCss } from '../../../../../../internal/style-injector/src/index.mjs';

var css$j = "[dir=rtl] .i18n_module_rtlIcon__278ecfc9{scale:-1 1}.i18n_module_rtlIcon__278ecfc9:dir(rtl){scale:-1 1}";
collectCss(css$j);

export { css$j as css };
//# sourceMappingURL=i18n.module.css.mjs.map
